import React, { Component, useEffect, useState } from 'react';
import './Manage.css';
import '../components/DataTables.css';
import withRouter from '../components/withRouter';
import { initDataTable, bulkSelect, confirmDelete, crudAlertControl } from "../Functions.js";
import ModalDelete from "../components/ModalDelete";
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

const OrganisationItems = (props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [items, setItems] = useState([]);
    const [locations, setLocations] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [current, setCurrent] = useState('');
    const [showModal, setShowModal] = useState(false);
    var lastID = '';
    const bulk = [];
    var CurrentObjectName = '';
    var CurrentObject = props.router.params.id;

    const deleteItem = async (row, objectid, name) => {
        const organisation = await import("../data/organisation.js");
        const data = await organisation.deleteObject(objectid, name);

        const settings = await import('../data/settings.js');
        const mbasettings = await settings.getMbaTemplates();
        
        if(data === "OK" && mbasettings[0].value === '1'){
            const responserule = await import("../mba/data/ResponseRules");
            const rule = await responserule.deleteFromObject(objectid);
        }
        
        crudAlertControl('delete', data);
        await getData();
    }

    const bulkDeleteItems = async (event, array) => {
        const organisation = await import("../data/organisation.js");
        array.forEach(async (item) => {
            const data = await organisation.deleteObject(item, '');

            if(data === "OK"){
                const responserule = await import("../mba/data/ResponseRules");
                const rule = await responserule.deleteFromObject(item);
            }

            crudAlertControl('delete', data);
        })
        await getData();
    }

    const bulkChangeLocation = async (event, array) => {
        const organisation = await import("../data/organisation.js");
        array.forEach(async (item) => {
            const data = await organisation.updateLocation(item, event.target.value);
            crudAlertControl('update', data);
        })
        await getData();
    }

    const bulkChangeRoute = async (event, array) => {
        const organisation = await import("../data/organisation.js");
        array.forEach(async (item) => {
            const data = await organisation.updateRoute(item, event.target.value);
            crudAlertControl('update', data);
        })
        await getData();
    }

    const addItem = async (event) => {
        event.preventDefault();
        
        const organisation = await import("../data/organisation.js");
        const data = await organisation.addObject(props.router.params.id, event.target.related.value, event.target.name.value, event.target.route.value);

        const settings = await import('../data/settings.js');
        const mbasettings = await settings.getMbaTemplates();

        if(mbasettings[0].value === '1'){
            const responserule = await import("../mba/data/ResponseRules");
            const rule = await responserule.insertFromTemplate(data[0].objectid, props.router.params.id, event.target.location.value);
        }


        if (props.router.params.id === 4 || props.router.params.id === 5) {
            const objectId = props.router.params.id === 4 ? props.router.params.id : lastID;
            [11, 12, 13].forEach((paramId) => organisation.addObjectParam(objectId, event.target.name.value, paramId, ''));
        }

        if(data && data.length > 0){
            navigate('/manage/organisation/details/' + data[0].id + '/' + props.router.params.id);
        }

        return false;
    }

    const getData = async (init) => {
        console.log(props.router.params);
        var Objects = ['location', 'building', 'floor', 'room', 'employee', 'client', 'sharedspace'];

        const [objectsData, routesData, organisationData] = await Promise.all([
            import("../data/objects.js"),
            import("../data/routes.js"),
            import("../data/organisation.js"),
        ])

        const data = await organisationData.getObjectType(Objects[(CurrentObject - 1)]);
        const routes = await routesData.getRoutes();
        const objects = await objectsData.getObjects();

        const objectitems = await Promise.all(data.map(async object => {
            const bread = CurrentObject == 1 || CurrentObject == 2 || CurrentObject == 3 ? await organisationData.getBreadcrumbs(Objects[(CurrentObject - 1)], object.relatedid, 1) : await organisationData.getBreadcrumbs(Objects[(CurrentObject - 2)], object.relatedid, 2);
            const breadcrumb = bread && bread[0] ? bread[0].floor.floorname + " > " + bread[0].building.buildingname : '';

            return {
                ...object,
                breadcrumb: CurrentObject != 3 || CurrentObject != 1 ? breadcrumb : []
            }
        }))
        
        setItems(objectitems);
        setRoutes(routes);
        setLocations(objects);
        setCurrent(Objects[(CurrentObject - 1)]);
        initDataTable();
    }

    const modalShow = () => {
        setShowModal(true);
    }

    const modalHide = () => {
        setShowModal(false);
    }

    useEffect(() => {
        getData();
    }, [])

    const objectNames = {
        location: t('location'),
        building: t('building'),
        floor: t('floor'),
        room: t('room'),
        employee: t('employee'),
        client: t('client'),
        sharedspace: t('sharedspace')
    };

    CurrentObjectName = objectNames[current];

    return (
        <React.Fragment>
            <div className='loc_content'>
            <div onClick={() => modalShow()} className="btn btn-add">{t('add')}</div>
            <h1><div className="goBackBtn" onClick={() => navigate('/manage/organisation/list/all')}><i className="fas fa-arrow-circle-left"></i></div> {CurrentObjectName}</h1>
            

            <div className="alert alert-success alert-add" role="alert">
                {t('neworgitem')}
            </div>

            <div className="alert alert-success alert-delete" role="alert">
                {t('delorgitem')}
            </div>

            <div className="alert alert-danger" role="alert">
                {t('somethingwrong')}
            </div>

            <div className="DataTable_Container">
                <div className="bulk" style={{ marginTop: '20px' }}>
                    <span style={{ color: '#000000', marginRight: '10px' }}>{t('bulkselect')}: </span>
                    <select style={{ marginRight: '10px' }} onChange={(event) => bulkChangeLocation(event, bulk)}>
                        <option value="0">{t('select')}</option>
                        {locations.map((location, i) => {
                            return (
                                <option key={i} value={location.objectid}>{location.objectname}</option>
                            )
                        })}
                    </select>
                    <select style={{ marginRight: '10px' }} onChange={(event) => bulkChangeRoute(event, bulk)}>
                        <option value="0">{t('select')}</option>
                        {routes.map((route, i) => {
                            return (
                                <option key={i} value={route.routeid}>{route.routename}</option>
                            )
                        })}
                    </select>
                    <i onClick={(event) => confirmDelete(t('delitem'), function () { bulkDeleteItems(event, bulk) })} className="btn-delete fas fa-trash-alt"></i>
                </div>
                <table id="DataTable" className="showHead table responsive nowrap" width="100%">
                    <thead>
                        <tr className="rowtitle">
                            <th></th>
                            <th>{t('name')}</th>
                            <th>{t('linkedto')}</th>
                            <th>{t('route')}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((organisation, i) => {

                            const mapping = {
                                location: { OrgID: 1, ObjectID: organisation.locationid, ObjectName: organisation.locationname },
                                building: { OrgID: 2, ObjectID: organisation.buildingid, ObjectName: organisation.buildingname },
                                floor: { OrgID: 3, ObjectID: organisation.floorid, ObjectName: organisation.floorname },
                                room: { OrgID: 4, ObjectID: organisation.roomid, ObjectName: organisation.roomname },
                                employee: { OrgID: 5, ObjectID: organisation.employeeid, ObjectName: organisation.employeename },
                                client: { OrgID: 6, ObjectID: organisation.clientid, ObjectName: organisation.clientname },
                                sharedspace: { OrgID: 7, ObjectID: organisation.spaceid, ObjectName: organisation.spacename }
                            };

                            const { OrgID, ObjectID, ObjectName } = mapping[current];

                            return (
                                <tr key={i}>
                                <td style={{ width: '1px' }} data-id={ObjectID}><input type="checkbox" className="bulkSelect" onChange={(event) => bulkSelect(event, bulk)} /></td>
                                <td onClick={(event) => { navigate(`/manage/organisation/details/${ObjectID}/${OrgID}`) }}>{ObjectName}</td>
                                <td>{organisation.breadcrumb ? organisation.breadcrumb : organisation.relatedname}</td>
                                <td>{organisation.routename}</td>
                                <td>{Object === 'location' ? '' : <i onClick={(event) => confirmDelete(t('delitem'), function () { deleteItem(event, ObjectID, ObjectName) })} className="btn-delete fas fa-trash-alt"></i>}</td>
                                </tr>
                            )
                            })}
                    </tbody>
                </table>
            </div>
            </div>

            <ModalDelete />

            {showModal && ( <div style={{ display: 'block' }} id="add" className="modal fade in">
                <div className="modal-content ">
                    <div className="modal-header">
                        <h4 className="modal-title">{t('addorgitem')}</h4>
                        <div onClick={() => modalHide()} className="close">&times;</div>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={(event) => addItem(event)}>
                            <div className="row">
                                <div className="col-md-12" style={{ padding: '0' }}>
                                    <div className="form-group">
                                        <label for="name">{t('name')}</label>
                                        <input type="text" name="name" id="name" className="form-control" required />
                                    </div>
                                </div>
                                <div className="col-md-12" style={{ padding: '0' }}>
                                    <div className="form-group">
                                        <label for="related">{t('location')}</label>
                                        <select name="related" id="related" className="form-control">
                                            <option value="0">{t('select')}</option>
                                            {locations.map((location, i) => {
                                                return (<option value={location.objectid}>{location.objectname}</option>)
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-12" style={{ padding: '0' }}>
                                    <div className="form-group">
                                        <label for="route">{t('route')}</label>
                                        <select name="route" id="route" className="form-control" required>
                                            <option value="">{t('select')}</option>
                                            {routes.map((route, i) => {
                                                return (<option value={route.routeid}>{route.routename}</option>)
                                            })}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6" style={{ padding: '0' }}>
                                    <div onClick={() => modalHide()} id="cancel" className="btn btn-red cancel">{t('cancel')}</div>
                                </div>
                                <div className="col-md-6" style={{ padding: '0' }}>
                                    <button type="submit" className="btn btn-green">{t('add')}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div> )}
        </React.Fragment>
    );
}

export default withRouter(OrganisationItems);